import { useTranslation } from 'react-i18next';
import React, { useState, useEffect, useCallback } from 'react';
import { Col, Row, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone } from '@fortawesome/fontawesome-svg-core/import.macro';
import { Switch } from "devextreme-react/switch";
import { useNavigate } from "react-router-dom";
import { connect } from 'react-redux';
import { updateLayout } from '../redux/supervisorSlice';
import { NumberBox } from "devextreme-react/number-box"

/*
!IMPORTANT: GUIDE TO CREATE WIDGETS
1. BACK END
    1.1 Create Service/Manager
    1.2 Create Controller (used to subscribe to events)
2. FRONT END
    2.1 Add Widget in widgets.js
    2.2 Add Widget in dashboard.js
    2.3 Create widget file
*/

function Widgets(props) {

    const { t } = useTranslation();

    const [callsWidgets, setCallsWidgets] = useState([
        { selected: false, multiple: false, instances: 0, width: 3, height: 6, resize: true, type: "queuedcallsdetail", title: "queuedcallsdetail", icon: <FontAwesomeIcon icon={duotone("phone-plus")} /> },
        { selected: false, multiple: true, instances: 0, width: 4, height: 3, resize: true, type: "incomingcallssummary", title: "incomingcalls", icon: <FontAwesomeIcon icon={duotone("phone-arrow-down-left")} /> },
        { selected: false, multiple: true, instances: 0, width: 4, height: 3, resize: true, type: "outgoingcallssummary", title: "outgoingcalls", icon: <FontAwesomeIcon icon={duotone("phone-arrow-up-right")} /> },
        { selected: false, multiple: false, instances: 0, width: 3, height: 3, resize: true, type: "queuecallssummary", title: "queuecalls", icon: <FontAwesomeIcon icon={duotone("phone-volume")} /> },
        { selected: false, multiple: true, instances: 0, width: 3, height: 6, resize: true, type: "servicequality", title: "servicequality", icon: <FontAwesomeIcon icon={duotone("chart-pie-simple")} /> },
        { selected: false, multiple: false, instances: 0, width: 3, height: 6, resize: true, type: "callsbygroup", title: "callsbygroup", icon: <FontAwesomeIcon icon={duotone("chart-simple")} /> },
        { selected: false, multiple: false, instances: 0, width: 3, height: 6, resize: true, type: "callsbyhour", title: "callsbyhour", icon: <FontAwesomeIcon icon={duotone("chart-line")} /> },
        { selected: false, multiple: false, instances: 0, width: 6, height: 6, resize: true, type: "groupsstats", title: "groupsstats", icon: <FontAwesomeIcon icon={duotone("object-group")} /> },
        { selected: false, multiple: false, instances: 0, width: 3, height: 6, resize: true, type: "queuecallslinechart", title: "queuecallslinechart", icon: <FontAwesomeIcon icon={duotone("scribble")} transform={{ rotate: 135 }} /> },
        { selected: false, multiple: false, instances: 0, width: 3, height: 6, resize: true, type: "maxwaitingtimebyhour", title: "maxwaitingtimebyhour", icon: <FontAwesomeIcon icon={duotone("hourglass-start")} /> },
        { selected: false, multiple: false, instances: 0, width: 3, height: 6, resize: true, type: "portsstatus", title: "portsstatus", icon: <FontAwesomeIcon icon={duotone("utility-pole-double")} /> },

    ]);

    const [agentsWidgets, setAgentsWidgets] = useState([
        { selected: false, multiple: false, instances: 0, width: 6, height: 6, resize: true, type: "agentscards", title: "agentspanel", icon: <FontAwesomeIcon icon={duotone("address-card")} /> },
        { selected: false, multiple: true, instances: 0, width: 6, height: 3, resize: true, type: "agentsstatussummary", title: "agentsstatus", icon: <FontAwesomeIcon icon={duotone("users")} /> },
        { selected: false, multiple: false, instances: 0, width: 6, height: 6, resize: true, type: "agentsdashboard", title: "agentsdashboard", icon: <FontAwesomeIcon icon={duotone("table")} /> },
    ]);

    const [campaignsWidgets, setCampaignsWidgets] = useState([
        { selected: false, multiple: true, instances: 0, width: 3, height: 3, resize: true, type: "campaignssummary", title: "campaignssummary", icon: <FontAwesomeIcon icon={duotone("chart-simple")} rotation={90} /> },
        { selected: false, multiple: false, instances: 0, width: 6, height: 6, resize: true, type: "campaignsstatus", title: "campaignsstatus", icon: <FontAwesomeIcon icon={duotone("address-book")} /> },
        { selected: false, multiple: false, instances: 0, width: 6, height: 6, resize: true, type: "dialerssummary", title: "dialerssummary", icon: <FontAwesomeIcon icon={duotone("phone-office")} /> },
        { selected: false, multiple: false, instances: 0, width: 6, height: 6, resize: true, type: "dialersstatus", title: "dialersstatus", icon: <FontAwesomeIcon icon={duotone("bell-on")} /> },
        { selected: false, multiple: false, instances: 0, width: 6, height: 6, resize: true, type: "campaignsstats", title: "campaignsstats", icon: <FontAwesomeIcon icon={duotone("table-cells")} /> }
    ]);

    const [socialNetworksWidgets, setSocialNetworksWidgets] = useState([
        { selected: false, multiple: false, instances: 0, width: 6, height: 6, resize: true, type: "chatsqueuedetail", title: "chatsqueuedetail", icon: <FontAwesomeIcon icon={duotone("message-plus")} /> },
        { selected: false, multiple: true, instances: 0, width: 6, height: 3, resize: true, type: "socialsummary", title: "socialnetwors", icon: <FontAwesomeIcon icon={duotone("chart-network")} rotation={90} /> },
        { selected: false, multiple: true, instances: 0, width: 3, height: 3, resize: true, type: "outgoingchatssummary", title: "outgoingchatssummary", icon: <FontAwesomeIcon icon={duotone("reply")} /> },
        { selected: false, multiple: false, instances: 0, width: 6, height: 6, resize: true, type: "activechats", title: "activechats", icon: <FontAwesomeIcon icon={duotone("wave-pulse")} /> }
    ]);

    const [aiWidgets, setAiWidgets] = useState([
        { selected: false, multiple: false, instances: 0, width: 6, height: 3, resize: true, type: "sentimentsummary", title: "sentimentsummary", icon: <FontAwesomeIcon icon={duotone("face-smile")} /> },
        { selected: false, multiple: false, instances: 0, width: 3, height: 6, resize: true, type: "sentimentbygroup", title: "sentimentbygroup", icon: <FontAwesomeIcon icon={duotone("chart-line-up")} /> },
        { selected: false, multiple: false, instances: 0, width: 3, height: 6, resize: true, type: "sentimentbyhour", title: "sentimentbyhour", icon: <FontAwesomeIcon icon={duotone("clock-two")} /> },
        { selected: false, multiple: false, instances: 0, width: 6, height: 6, resize: true, type: "analysisbycriteria", title: "analysisbycriteria", icon: <FontAwesomeIcon icon={duotone("magnifying-glass-chart")} /> },
        { selected: false, multiple: false, instances: 0, width: 6, height: 6, resize: true, type: "analysisbycategory", title: "analysisbycategory", icon: <FontAwesomeIcon icon={duotone("bookmark")} /> },
        { selected: false, multiple: false, instances: 0, width: 6, height: 6, resize: true, type: "analysismoodtable", title: "analysisbymood", icon: <FontAwesomeIcon icon={duotone("file-chart-column")} /> }
    ]);

    const [widgets, setWidgets] = useState("calls");

    const [layout, setLayout] = useState([]);

    const navigate = useNavigate();

    useEffect(() => {
        // component mounts
        let data = [];
        let callsWidgetsLocal = callsWidgets;
        let agentsWidgetsLocal = agentsWidgets;
        let campaignsWidgetsLocal = campaignsWidgets;
        let socialNetworksWidgetsLocal = socialNetworksWidgets;
        let aiWidgetsLocal = aiWidgets;

        props.layout.forEach((v, i) => {
            let widget = null;

            widget = callsWidgetsLocal.find(x => x.type === v.type);
            if (widget) {
                if (widget.multiple) {
                    let existingWidget = data.find(x => x.type === widget.type);
                    if (!existingWidget)
                        existingWidget = widget;
                    existingWidget.instances += 1;
                    data.push(existingWidget);
                } else {
                    data.push(widget);
                }
            }

            widget = agentsWidgetsLocal.find(x => x.type === v.type);

            if (widget) {
                if (widget.multiple) {
                    let existingWidget = data.find(x => x.type === widget.type);
                    if (!existingWidget)
                        existingWidget = widget;
                    existingWidget.instances += 1;
                    data.push(existingWidget);
                } else {
                    data.push(widget);
                }
            }

            widget = campaignsWidgetsLocal.find(x => x.type === v.type);

            if (widget)
                data.push(widget);

            widget = socialNetworksWidgets.find(x => x.type === v.type);

            if (widget) {
                if (widget.multiple) {
                    let existingWidget = data.find(x => x.type === widget.type);
                    if (!existingWidget)
                        existingWidget = widget;
                    existingWidget.instances += 1;
                    data.push(existingWidget);
                } else {
                    data.push(widget);
                }
            }

            widget = aiWidgets.find(x => x.type === v.type);
            if (widget)
                data.push(widget);

        });

        callsWidgetsLocal.forEach((v, i) => {
            v.selected = data.map(x => x.type).indexOf(v.type) > -1;
        });

        agentsWidgetsLocal.forEach((v, i) => {
            v.selected = data.map(x => x.type).indexOf(v.type) > -1;
        });

        campaignsWidgetsLocal.forEach((v, i) => {
            v.selected = data.map(x => x.type).indexOf(v.type) > -1;
        });

        socialNetworksWidgetsLocal.forEach((v, i) => {
            v.selected = data.map(x => x.type).indexOf(v.type) > -1;
        });

        aiWidgetsLocal.forEach((v, i) => {
            v.selected = data.map(x => x.type).indexOf(v.type) > -1;
        });

        setLayout(data);
        setCallsWidgets(callsWidgetsLocal);
        setAgentsWidgets(agentsWidgetsLocal);
        setCampaignsWidgets(campaignsWidgetsLocal);
        setSocialNetworksWidgets(socialNetworksWidgetsLocal);
        setAiWidgets(aiWidgetsLocal);

        return () => {
            // component unmounts
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const toggleWidgets = useCallback((selectedWidget) => {
        setWidgets(selectedWidget);
    }, []);

    const updateWidgets = () => {
        let data = [];

        layout.forEach(x => {

            let xPos = 0;
            let yPos = 0;
            let width = x.width;
            let height = x.height;
            // eslint-disable-next-line no-loop-func
            while (data.some(item => item.x < xPos + width && item.x + item.w > xPos && item.y < yPos + height && item.y + item.h > yPos)) {
                xPos++;
                if (xPos + width > 12) {
                    xPos = 0;
                    yPos++;
                }
            }

            data.push({ i: data.length.toString(), x: xPos, y: yPos, w: x.width, h: x.height, isResizable: x.resize, type: x.type });

        });


        props.updateLayout(data);
        navigate("/main/dashboard")
    }

    const updateLayout = (elem, selected) => {


        let data = layout;
        if (selected) {
            data.push(elem);
        } else {
            data = data.filter(x => x.type !== elem.type);
        }

        setLayout(data);
        setCallsWidgets(prevState =>
            prevState.map(w =>
                w.type === elem.type ? { ...w, selected } : w
            )
        );
        setAgentsWidgets(prevState =>
            prevState.map(w =>
                w.type === elem.type ? { ...w, selected } : w
            )
        );

        setCampaignsWidgets(prevState =>
            prevState.map(w =>
                w.type === elem.type ? { ...w, selected } : w
            )
        );

        setSocialNetworksWidgets(prevState =>
            prevState.map(w =>
                w.type === elem.type ? { ...w, selected } : w
            )
        );

        setAiWidgets(prevState =>
            prevState.map(w =>
                w.type === elem.type ? { ...w, selected } : w
            )
        );
    }

    const numberChange = (elem, instances) => {
        let data = layout;
        data = data.filter(x => x.type !== elem.type);

        if (instances > 0) {
            for (var i = 0; i < instances; i++) {
                data.push(elem);
            }
        }

        setLayout(data);

        setCallsWidgets(prevState =>
            prevState.map(w =>
                w.type === elem.type ? { ...w, instances } : w
            )
        );

        setAgentsWidgets(prevState =>
            prevState.map(w =>
                w.type === elem.type ? { ...w, instances } : w
            )
        );

        setCampaignsWidgets(prevState =>
            prevState.map(w =>
                w.type === elem.type ? { ...w, instances } : w
            )
        );

        setSocialNetworksWidgets(prevState =>
            prevState.map(w =>
                w.type === elem.type ? { ...w, instances } : w
            )
        );

        setAiWidgets(prevState =>
            prevState.map(w =>
                w.type === elem.type ? { ...w, instances } : w
            )
        );
    }

    const draw = (elem) => {
        let element = null;

        if (!elem.multiple) {
            element = (<Switch
                value={elem.selected}
                rtlEnabled={props.rtl}
                onValueChanged={e => {
                    if (e.event !== undefined)
                        updateLayout(elem, e.value);
                }}
                switchedOnText={t("yes")} switchedOffText={t("no")} />)
        } else {
            element = (<NumberBox rtlEnabled={props.rtl} width={70} min={0} max={9} showSpinButtons={true} value={elem.instances} onValueChanged={e => {
                if (e.event !== undefined)
                    numberChange(elem, e.value)
            }}>
            </NumberBox>)
        }

        return element;
    }

    return (
        <Row className='content'>
            <div className={"card card-flush overflow-hidden h-lg-100"}>
                <div className="card-header pt-5">
                    <h3 className="card-title align-items-start flex-column">
                        <span className="card-label fw-bold text-dark "><FontAwesomeIcon size='lg' icon={duotone("hexagon-plus")} /> {t("addwidgets")}</span>
                    </h3>
                    <div className="card-toolbar">

                    </div>
                </div>
                <div className="card-body">
                    <Row >
                        <Col></Col>
                        <Col>
                            <Button variant={widgets === "calls" ? "primary" : "light"} onClick={e => { toggleWidgets("calls") }} className="w-100"><FontAwesomeIcon size='lg' icon={duotone("phone")} /> {t("calls")}</Button>
                        </Col>
                        <Col>
                            <Button variant={widgets === "agents" ? "primary" : "light"} onClick={e => { toggleWidgets("agents") }} className="w-100"><FontAwesomeIcon size='lg' icon={duotone("user-headset")} /> {t("agents")}</Button>
                        </Col>
                        <Col>
                            <Button variant={widgets === "campaigns" ? "primary" : "light"} onClick={e => { toggleWidgets("campaigns") }} className="w-100"><FontAwesomeIcon size='lg' icon={duotone("address-book")} /> {t("campaigns")}</Button>
                        </Col>
                        <Col>
                            <Button variant={widgets === "socialnetworks" ? "primary" : "light"} onClick={e => { toggleWidgets("socialnetworks") }} className="w-100"><FontAwesomeIcon size='lg' icon={duotone("chart-network")} rotation={90} /> {t("socialnetworks")}</Button>
                        </Col>
                        <Col>
                            <Button variant={widgets === "ai" ? "primary" : "light"} onClick={e => { toggleWidgets("ai") }} className="w-100"><FontAwesomeIcon size='lg' icon={duotone("microchip-ai")} /> {t("AI")}</Button>
                        </Col>
                        <Col></Col>
                    </Row>

                    <Row style={{ display: widgets === "calls" ? "flex" : "none" }}>
                        <Col>
                            <Row>
                                {
                                    callsWidgets.map(elem => {
                                        return <Col lg={3} key={elem.type}>
                                            <div className={"card card-flush overflow-hidden h-lg-20"} style={{ backgroundColor: "var(--kt-page-bg)", marginTop: "10px" }}>
                                                <div className="card-header py-5">
                                                    <h3 className="card-title align-items-start flex-column">
                                                        <span className="card-label fw-bold text-dark">{elem.icon} {t(elem.title)}</span>
                                                    </h3>
                                                    <div className="card-toolbar">
                                                        {draw(elem)}
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                    })
                                }
                            </Row>
                        </Col>
                    </Row>
                    <Row style={{ display: widgets === "agents" ? "flex" : "none" }}>
                        {
                            agentsWidgets.map(elem => {
                                return <Col lg={3} key={elem.type}>
                                    <div className={"card card-flush overflow-hidden h-lg-20"} style={{ backgroundColor: "var(--kt-page-bg)", marginTop: "10px" }}>
                                        <div className="card-header py-5">
                                            <h3 className="card-title align-items-start flex-column">
                                                <span className="card-label fw-bold text-dark">{elem.icon} {t(elem.title)}</span>
                                            </h3>
                                            <div className="card-toolbar">
                                                {draw(elem)}
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                            })
                        }
                    </Row>
                    <Row style={{ display: widgets === "campaigns" ? "flex" : "none" }}>
                        {
                            campaignsWidgets.map(elem => {
                                return <Col lg={3} key={elem.type}>
                                    <div className={"card card-flush overflow-hidden h-lg-20"} style={{ backgroundColor: "var(--kt-page-bg)", marginTop: "10px" }}>
                                        <div className="card-header py-5">
                                            <h3 className="card-title align-items-start flex-column">
                                                <span className="card-label fw-bold text-dark">{elem.icon} {t(elem.title)}</span>
                                            </h3>
                                            <div className="card-toolbar">
                                                {draw(elem)}
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                            })
                        }
                    </Row>
                    <Row style={{ display: widgets === "socialnetworks" ? "flex" : "none" }}>
                        {
                            socialNetworksWidgets.map(elem => {
                                return <Col lg={3} key={elem.type}>
                                    <div className={"card card-flush overflow-hidden h-lg-20"} style={{ backgroundColor: "var(--kt-page-bg)", marginTop: "10px" }}>
                                        <div className="card-header py-5">
                                            <h3 className="card-title align-items-start flex-column">
                                                <span className="card-label fw-bold text-dark">{elem.icon} {t(elem.title)}</span>
                                            </h3>
                                            <div className="card-toolbar">
                                                {draw(elem)}
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                            })
                        }
                    </Row>
                    <Row style={{ display: widgets === "ai" ? "flex" : "none" }}>
                        {
                            aiWidgets.map(elem => {
                                return <Col lg={3} key={elem.type}>
                                    <div className={"card card-flush overflow-hidden h-lg-20"} style={{ backgroundColor: "var(--kt-page-bg)", marginTop: "10px" }}>
                                        <div className="card-header py-5">
                                            <h3 className="card-title align-items-start flex-column">
                                                <span className="card-label fw-bold text-dark">{elem.icon} {t(elem.title)}</span>
                                            </h3>
                                            <div className="card-toolbar">
                                                {draw(elem)}
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                            })
                        }
                    </Row>
                    <Row>
                        <Col>
                            <Button variant={"primary"} onClick={e => { updateWidgets() }} className='float-end'>{t("send")}</Button>
                        </Col>
                    </Row>
                </div>


            </div>
        </Row>
    )
}
const mapStateToProps = (state) => {
    return {
        token: state.supervisor.token,
        layout: state.supervisor.layout,
        rtl: state.parameters.rtl
    };
};

export default connect(mapStateToProps, { updateLayout })(Widgets);
